<template>
  <HeaderSection />
  <article :id="($route.name !== 'Home') ? 'pages' : ''">
    <router-view :key="$route.fullPath" />
  </article>
  <FloatingMenuBox />
  <FooterSection />
  <Login v-if="loginMode !== 'none'" />
  <GlobalOverlay/>
</template>
<script setup>
import {computed, onMounted,} from 'vue';
import HeaderSection from '@/components/layout/Header.vue';
import FooterSection from '@/components/layout/Footer.vue';
import FloatingMenuBox from '@/components/layout/FloatingMenuBox.vue';
import Login from '@/components/auth/Login.vue';
import GlobalOverlay from "@/components/ui/GlobalOverlay.vue";
import {useUiStore} from "@/store/useUiStore";

const uiStore = useUiStore();
const loginMode = computed(() => uiStore.loginMode);

const redirectIfWww = () => {
  const host = window.location.hostname;
  const url = window.location.href;

  if (host.startsWith('www.')) {
    const newUrl = url.replace('://www.', '://');
    window.location.replace(newUrl);
  }
};

onMounted(() => {
  redirectIfWww();

});

</script>

<style>
img,video { /* 이벤트 차단 */
  pointer-events: none;
}
</style>
